import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Spin } from 'antd';

export default function Demo() {
  const [iframeLoaded, setIframeLoaded] = useState(false);

  return (
    <div style={{ padding: '4rem 0' }}>
      <Helmet>
        <title>Book a Shipmnts Demo: See the Freight ERP in Action</title>
        <meta name="description" content="Book a personalised demo of Shipmnts freight ERP. See air & ocean forwarding, customs compliance, finance, warehouse, and transport management: all in one platform." />
      </Helmet>
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '0 2rem 3rem', textAlign: 'center' }}>
        <h1 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '1rem', color: '#1a1a2e' }}>
          Book a Shipmnts Demo
        </h1>
        <p style={{ fontSize: '1.1rem', color: '#555', lineHeight: 1.7, maxWidth: 640, margin: '0 auto' }}>
          See how 6,000+ users across 180 freight forwarding companies manage their entire operations on Shipmnts.
          In a 30-minute walkthrough, explore air &amp; ocean freight forwarding, customs compliance,
          integrated finance &amp; invoicing, warehouse management, and real-time analytics: all in one platform.
        </p>
      </div>
      <div style={{ position: 'relative', width: '100%', height: '100vh', overflow: 'hidden' }}>
        {!iframeLoaded && (
          <div
            style={{
              position: 'absolute',
              inset: 0,
              zIndex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 16,
              background: '#fafafa',
            }}
            aria-busy="true"
            aria-live="polite"
          >
            <Spin size="large" />
            <span style={{ color: 'rgba(0,0,0,0.45)', fontSize: 14 }}>Loading...</span>
          </div>
        )}
        <iframe
          src="https://share.hsforms.com/1bgqKhlUxTRSRt1HEWX-Jsg1yzii"
          frameBorder="0"
          title="HubSpot Demo Form"
          onLoad={() => setIframeLoaded(true)}
          style={{ border: 'none', width: '100%', height: '100%', display: 'block' }}
        />
      </div>
    </div>
  );
}
